import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CodigosRoutes } from './codigos.routing';
import { NotificationsComponent } from '../../notifications/notifications.component';
import { UpgradeComponent } from '../../upgrade/upgrade.component';

import { CodigosComponent } from './codigos.component';

import { AuthenticationService } from '../../services/auth/auth.service';

import {
  MatButtonModule,
  MatInputModule,
  MatRippleModule,
  MatTooltipModule,
} from '@angular/material';
@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatRippleModule,
    MatInputModule,
    MatTooltipModule,
    FormsModule,
    RouterModule.forChild(CodigosRoutes)
  ],
  declarations: [
    CodigosComponent,
  ],
  providers: [
    AuthenticationService
  ]
})

export class CodigosModule {}



// WEBPACK FOOTER //
// ./src/app/pages/codigos/codigos.module.ts